import { c as _c } from "react/compiler-runtime";
import { getFlatViews } from '@lib/tools/_get-flat-views';
import style from './WindowViews.module.scss';
const WindowViews = t0 => {
  const $ = _c(16);
  const {
    flat
  } = t0;
  const flatNumber = Number(flat?.number);
  const bulkNumber = flat?.bulk?.id;
  let t1;
  if ($[0] !== bulkNumber || $[1] !== flatNumber) {
    t1 = getFlatViews(flatNumber, bulkNumber);
    $[0] = bulkNumber;
    $[1] = flatNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const views = t1;
  if (views) {
    let t2;
    if ($[3] !== views.top) {
      t2 = views.top && <div className={`${style.view} ${style.view__top}`}>{views.top}</div>;
      $[3] = views.top;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== views.right) {
      t3 = views.right && <div className={`${style.view} ${style.view__right}`}>{views.right}</div>;
      $[5] = views.right;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== views.bottom) {
      t4 = views.bottom && <div className={`${style.view} ${style.view__bottom}`}>{views.bottom}</div>;
      $[7] = views.bottom;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== views.left) {
      t5 = views.left && <div className={`${style.view} ${style.view__left}`}>{views.left}</div>;
      $[9] = views.left;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
      t6 = <>{t2}{t3}{t4}{t5}</>;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  return null;
};
export default WindowViews;